import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import ConversionDialog from 'components/Modals/ConversionDialog';
import { SessionFlow } from 'services/api/entities';
import { getOriginURL } from 'services/helpers/urlOrigin';
import { useStripeSession } from 'services/hooks';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { events } from 'services/analytics';
import useAnalytics from 'services/hooks/analytics';

interface PropsType {
  isOpen: boolean;
  onClose: () => void;
}

export const PersonalUserStemsDownloadLimitDialog = ({
  onClose,
  isOpen,
}: PropsType) => {
  const { t } = useTranslation();
  const reactLocation = useLocation();
  const { location } = window;
  const { track } = useAnalytics();

  const { createUserPortalSession } = useStripeSession();

  const createStripeSession = useCallback(
    (flowType: SessionFlow) => {
      const returnUrl = getOriginURL(location.origin, reactLocation.pathname);
      createUserPortalSession({ returnUrl, flowType });
    },
    [location.origin, reactLocation.pathname, createUserPortalSession]
  );

  const onSubmitClick = useCallback(() => {
    track(
      events.upgradeSubscription(
        'download_limit_reached_modal',
        AnalyticsEventLocation.DOWNLOAD_LIMIT_REACHED_MODAL
      )
    );
    createStripeSession(SessionFlow.UPDATE);
  }, [createStripeSession, track]);

  return (
    <ConversionDialog
      title={t('download:stems:limit:title')}
      description={t('download:stems:limit:descriptionPersonal')}
      closeText={t('download:action:cancel')}
      submitText={t('download:action:upgrade')}
      state={{
        isOpen,
        isLoading: false,
        error: null,
      }}
      action={{
        onClose,
        onSubmit: onSubmitClick,
        onExited: onClose,
      }}
    />
  );
};

export default PersonalUserStemsDownloadLimitDialog;
